export default class AuthApi {
  constructor(client) {
    this.client = client;
  }

  async register({ first_name, last_name, email, password }) {
    return this.client.request('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify({ first_name, last_name, email, password }),
    });
  }

  async login({ email, password }) {
    const data = await this.client.request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
    if (data.token) this.client.setToken(data.token);
    return data;
  }

  async getProfile() {
    return this.client.request('/api/user/profile', { method: 'GET' });
  }

  async verifyEmail(token) {
    // token passed as query param
    return this.client.request(`/api/auth/verify?token=${encodeURIComponent(token)}`, {
      method: 'GET',
    });
  }
}
